import { utils } from '@atlaskit/util-service-support';
export let TeamMembershipSettings = /*#__PURE__*/function (TeamMembershipSettings) {
  TeamMembershipSettings["OPEN"] = "OPEN";
  TeamMembershipSettings["MEMBER_INVITE"] = "MEMBER_INVITE";
  TeamMembershipSettings["ADMIN_INVITE"] = "ADMIN_INVITE";
  return TeamMembershipSettings;
}({});
export const getTeamData = (url, teamAri) => {
  const parts = teamAri.split('/');
  const id = parts[parts.length - 1];
  const options = {
    path: `/gateway/api/v3/teams/${encodeURIComponent(id)}`,
    requestInit: {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
  };
  return utils.requestService({
    url
  }, options);
};